import axios from "axios";
import { SERVER_URL } from "../const";

const getSelectedIEC = () => {
    try {
        return sessionStorage.getItem("selectedIEC") || "";
    } catch (e) {
        return "";
    }
};

/**
 * Get all charts for the current user
 */
export const getChartsService = async (token) => {
    try {
        const iec = getSelectedIEC();
        const url = iec ? `${SERVER_URL}/charts?iec_no=${encodeURIComponent(iec)}` : `${SERVER_URL}/charts`;
        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching charts:", error);
        throw error;
    }
};

/**
 * Create a new chart
 */
export const createChartService = async (token, chartData) => {
    try {
        const iec = getSelectedIEC();
        const data = (iec && iec !== 'ALL') ? { ...chartData, iec_no: iec } : chartData;
        const response = await axios.post(`${SERVER_URL}/charts`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating chart:", error);
        throw error;
    }
};

/**
 * Update an existing chart
 */
export const updateChartService = async (token, chartId, chartData) => {
    try {
        const response = await axios.put(`${SERVER_URL}/charts/${chartId}`, chartData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating chart:", error);
        throw error;
    }
};

/**
 * Pin or unpin a chart for the dashboard
 */
export const pinChartService = async (token, chartId, pinData) => {
    try {
        const response = await axios.patch(`${SERVER_URL}/charts/${chartId}/pin`, pinData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error pinning chart:", error);
        throw error;
    }
};

/**
 * Delete a chart
 */
export const deleteChartService = async (token, chartId) => {
    try {
        const response = await axios.delete(`${SERVER_URL}/charts/${chartId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting chart:", error);
        throw error;
    }
};

/**
 * Get available columns for a report type
 */
export const getReportColumnsService = async (token, reportType) => {
    try {
        const response = await axios.get(`${SERVER_URL}/charts/columns?report_type=${encodeURIComponent(reportType)}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching report columns:", error);
        throw error;
    }
};

/**
 * Get chart preview data with aggregation
 */
export const getGraphViewDataService = async (token, config) => {
    try {
        const iec = getSelectedIEC();
        const data = iec ? { ...config, iec_no: iec } : config;
        const response = await axios.post(`${SERVER_URL}/charts/preview`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching chart preview data:", error);
        throw error;
    }
};

/**
 * Get all report types from the column mapping
 */
export const getReportTypesService = () => {
    // These are the 13 report types from report_column_mapping.json
    return [
        "BRC Report",
        "IGST Status",
        "DBK AIR Status and Liability",
        "RODTEP Status /Scrip and Liability",
        "Clearance Time Import",
        "Clearance Time Export",
        "Bond Report",
        "EPCG Report",
        "Advance Auth Export",
        "Advance Auth Import",
        "Adv Auth Excess Imp",
        "RODTEP Scrip Ledger",
        "FTA",
        "FTA Opp",
        "FTA Applicability",
        "Inconsistency Report",
        "Duty Savings - Import",
        "Duty Savings - Export",
        "D2D Import - BOE Item Wise Summary",
        "D2D Import - BOE Summary",
        "D2D Import - Invoice Wise",
        "D2D Import - Bond Details",
        "D2D Import - Container Details",
        "D2D Import - Manifest Details",
        "D2D Import - Payment Details",
        "D2D Import - License Details",
        "D2D Import - Single Window Declaration",
        "D2D Export - SHB Summary",
        "D2D Export - Item Wise Shipping Bill",
        "D2D Export - Invoice Wise SHB",
        "D2D Export - Container Details",
        "D2D Export - Challan Details",
        "D2D Export - Jobbing Details",
        "D2D Export - AA DFIA License Details",
        "D2D Export - Drawback Details",
        "D2D Export - Third Party Details",
        "D2D Export - Item Manufacturer Details",
        "D2D Export - RODTEP Details",
        "D2D Export - Single Window Declaration",
        "Summary-Imp",
        "Summary-Exp"
    ];
};
